var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "file-preview" }, [
    _vm.allFilesEmpty
      ? _c(
          "div",
          { staticClass: "empty-state" },
          [
            _c("el-image", { attrs: { alt: "暂无文件" } }, [
              _vm.fileList.length <= 0
                ? _c(
                    "div",
                    {
                      staticClass: "el-image__error",
                      staticStyle: { "font-size": "x-large" },
                      attrs: { slot: "error" },
                      slot: "error",
                    },
                    [_vm._v("暂无文件")]
                  )
                : _vm._e(),
            ]),
          ],
          1
        )
      : _vm._e(),
    _c("div", { staticClass: "preview-row" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.imageFiles.length > 0,
              expression: "imageFiles.length > 0",
            },
          ],
          staticClass: "preview-section",
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "image-preview-container",
            },
            [
              _vm.imageFiles.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "image-wrapper",
                      on: {
                        mousemove: _vm.handleMouseMove,
                        mouseleave: _vm.handleMouseLeave,
                      },
                    },
                    [
                      _c(
                        "el-image",
                        {
                          key: _vm.currentImageIndex,
                          attrs: {
                            lazy: "",
                            src: _vm.imageFiles[_vm.currentImageIndex].fileUrl,
                            alt: "Preview",
                            "preview-src-list": _vm.imageFiles.map(function (
                              file
                            ) {
                              return file.fileUrl
                            }),
                            "preview-index": _vm.currentImagePreviewIndex,
                            fit: "contain",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "el-image__error",
                              staticStyle: { "font-size": "x-large" },
                              attrs: { slot: "error" },
                              slot: "error",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.isFileSupported(
                                      _vm.imageFiles[_vm.currentImageIndex]
                                        .fileUrl
                                    )
                                      ? "图片加载失败"
                                      : "暂不支持" +
                                          _vm.getFileExtension(
                                            _vm.imageFiles[
                                              _vm.currentImageIndex
                                            ].fileUrl
                                          ) +
                                          "格式文件预览"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm.imageFiles.length > 1
                        ? _c(
                            "button",
                            {
                              staticClass: "nav-button prev",
                              style: { opacity: _vm.showPrev ? 1 : 0 },
                              on: { click: _vm.prevImage },
                            },
                            [_vm._v(" < ")]
                          )
                        : _vm._e(),
                      _vm.imageFiles.length > 1
                        ? _c(
                            "button",
                            {
                              staticClass: "nav-button next",
                              style: { opacity: _vm.showNext ? 1 : 0 },
                              on: { click: _vm.nextImage },
                            },
                            [_vm._v(" > ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass: "el-image__error",
                      staticStyle: { "font-size": "x-large" },
                    },
                    [_vm._v("暂无图片")]
                  ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.pdfFiles.length > 0,
              expression: "pdfFiles.length > 0",
            },
          ],
          staticClass: "preview-section",
        },
        _vm._l(_vm.pdfFiles, function (pdfFile, index) {
          return _c("div", { key: index, staticClass: "pdf-item" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
              },
              [
                _c("pdf", {
                  attrs: {
                    src: _vm.pdfUrls[index],
                    page: _vm.pageNumbers[index],
                  },
                  on: {
                    "num-pages": function ($event) {
                      return _vm.onNumPages(index, $event)
                    },
                  },
                }),
                _c(
                  "div",
                  { staticClass: "pdf-nav" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "medium",
                          disabled: _vm.pageNumbers[index] <= 1,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.previousPage(index)
                          },
                        },
                      },
                      [_vm._v(" 上一页 ")]
                    ),
                    _c("span", { staticStyle: { "font-size": "medium" } }, [
                      _vm._v(
                        " 当前页: " +
                          _vm._s(_vm.pageNumbers[index]) +
                          " / 总页: " +
                          _vm._s(_vm.numPages[index]) +
                          " "
                      ),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "medium",
                          disabled:
                            _vm.pageNumbers[index] >= _vm.numPages[index],
                        },
                        on: {
                          click: function ($event) {
                            return _vm.nextPage(index)
                          },
                        },
                      },
                      [_vm._v(" 下一页 ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "preview-row" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.wordFiles.length > 0,
              expression: "wordFiles.length > 0",
            },
          ],
          staticClass: "preview-section",
        },
        _vm._l(_vm.wordFiles, function (wordFile, index) {
          return _c("div", { key: index, staticClass: "word-item" }, [
            _c("div", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "word-content",
              domProps: { innerHTML: _vm._s(_vm.wordContents[index]) },
            }),
          ])
        }),
        0
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.excelFiles.length > 0,
              expression: "excelFiles.length > 0",
            },
          ],
          staticClass: "preview-section",
        },
        _vm._l(_vm.excelFiles, function (excelFile, index) {
          return _c(
            "div",
            { key: index, staticClass: "excel-item" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.excelDatas[index],
                    border: "",
                    stripe: "",
                  },
                },
                _vm._l(_vm.excelHeaders[index], function (header, colIndex) {
                  return _c("el-table-column", {
                    key: colIndex,
                    attrs: { label: header, prop: colIndex.toString() },
                  })
                }),
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.textFiles.length > 0,
              expression: "textFiles.length > 0",
            },
          ],
          staticClass: "preview-section",
        },
        _vm._l(_vm.textFiles, function (textFile, index) {
          return _c("div", { key: index, staticClass: "text-item" }, [
            _c("div", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "text-content",
              domProps: { innerHTML: _vm._s(_vm.textContents[index]) },
            }),
          ])
        }),
        0
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.videoFiles.length > 0,
              expression: "videoFiles.length > 0",
            },
          ],
          staticClass: "preview-section",
        },
        _vm._l(_vm.videoFiles, function (videoFile, index) {
          return _c("div", { key: index, staticClass: "video-item" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
              },
              [
                _c(
                  "video",
                  {
                    staticStyle: { width: "100%", "max-height": "700px" },
                    attrs: { src: videoFile.fileUrl, controls: "" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "el-image__error",
                        staticStyle: { "font-size": "x-large" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.isFileSupported(videoFile.fileUrl)
                                ? "视频加载失败"
                                : "暂不支持" +
                                    _vm.getFileExtension(videoFile.fileUrl) +
                                    "格式文件预览"
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ])
        }),
        0
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.unsupportedFiles.length > 0,
              expression: "unsupportedFiles.length > 0",
            },
          ],
          staticClass: "preview-section unsupported-files",
        },
        _vm._l(_vm.unsupportedFiles, function (file, index) {
          return _c(
            "div",
            { key: index, staticClass: "unsupported-file-item" },
            [
              _c(
                "div",
                {
                  staticClass: "el-image__error",
                  staticStyle: { "font-size": "x-large" },
                },
                [
                  _vm._v(
                    " 暂不支持" +
                      _vm._s(_vm.getFileExtension(file.fileUrl)) +
                      "格式文件预览 "
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }